<template>
  <div class="parts-filters" v-if="marks.length">
    <div class="parts-filters-desktop">
      <v-select v-model="selectedMark" :options="marks" label="name"
                :searchable="false" :clearable="false" :placeholder="$t('maker_engine')">
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><i class="svg-icon arrow-mobile2"></i></span>
        </template>
      </v-select>
      <v-select v-model="selectedDetail" :options="details" label="name"
                :searchable="false" :clearable="false" :placeholder="$t('model_engine')"
                :disabled="!selectedMark || !details.length">
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><i class="svg-icon arrow-mobile2"></i></span>
        </template>
      </v-select>
      <button @click.prevent="clear" :disabled="!selectedMark"><i class="svg-icon cross-little"></i></button>
      <button @click.prevent="apply" :disabled="!selectedMark">{{ $t('show') }}</button>
    </div>

    <div class="parts-filters-mobile">
      <div>
        <div class="parts-filters-items" v-if="!actionMark && !actionEngine">
          <div class="parts-filters-item" @click="actionMark = true">
            <span v-if="!selectedMark">{{ $t('maker_engine') }}</span>
            <span v-else>{{ selectedMark.name }}</span>
            <i class="svg-icon arrow-mobile"></i>
          </div>

          <div class="parts-filters-item" @click="actionEngine = true" :class="{'not-active': !selectedMark}">
            <span v-if="!selectedDetail">{{ $t('model_engine') }}</span>
            <span v-else>{{ selectedDetail.name }}</span>
            <i class="svg-icon arrow-mobile"></i>
          </div>
        </div>

        <div class="parts-filters-values" v-if="actionMark">
          <div class="values-back" @click="actionMark = false">
            <i class="svg-icon arrow-mobile"></i>
            <span>{{ $t('maker_engine') }}</span>
          </div>
          <div class="items-value">
            <div class="item-value" v-for="mark in marks" @click="selectedMark = mark; actionMark = false">{{
                mark.name
              }}
            </div>
          </div>
        </div>

        <div class="parts-filters-values" v-if="actionEngine">
          <div class="values-back" @click="actionEngine = false">
            <i class="svg-icon arrow-mobile"></i>
            <span>{{ $t('model_engine') }}</span>
          </div>
          <div class="items-value">
            <div class="item-value" v-for="detail in details" @click="selectedDetail = detail; actionEngine = false">{{
                detail.name
              }}
            </div>
          </div>
        </div>

        <button v-if="!actionMark && !actionEngine" @click.prevent="apply"
                :disabled="!selectedMark">{{
            $t('apply_filters')
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import {CarMark, CarModelDetail} from '@/models/parts';

export default {
  props: ['category', 'filter'],
  components: {
    vSelect,
  },
  data() {
    return {
      marks: [],
      details: [],
      selectedMark: null,
      selectedDetail: null,
      actionMark: false,
      actionEngine: false
    }
  },
  computed: {
    queryParams() {
      const params = {...this.$route.query};
      if (this.category) {
        params.category = this.category.id;
      }
      if (this.filter) {
        params.filter = this.filter;
      }
      return params;
    },
  },
  watch: {
    async queryParams() {
      const params = {...this.queryParams};
      if (this.selectedMark) {
        params.mark = this.selectedMark.id;
      }
      this.marks = await CarMark.params(params).get();
    },
    async selectedMark() {
      if (this.selectedMark) {
        const params = {...this.queryParams};
        if (this.selectedMark) {
          params.mark = this.selectedMark.id;
        }
        this.details = await CarModelDetail.params(params).get();
        if (this.selectedDetail && !this.details.find(x => x.id === this.selectedDetail.id)) {
          this.selectedDetail = null;
        }
      } else {
        this.details = [];
        this.selectedDetail = null;
      }
      this.$emit('set-selected-parts', this.selectedMark?.name, this.selectedDetail?.name);
    },
  },
  async fetch() {
    this.marks = await CarMark.config({count_loading: true}).params(this.queryParams).get();
    if (this.queryParams.mark) {
      this.selectedMark = this.marks.find(x => x.id === parseInt(this.queryParams.mark));
      if (this.selectedMark && this.queryParams.detail) {
        const params = {...this.queryParams};
        params.mark = this.selectedMark.id;
        this.details = await CarModelDetail.config({count_loading: true}).params(params).get();
        this.selectedDetail = this.details.find(x => x.id === parseInt(this.queryParams.detail));
      }
      this.$emit('set-selected-parts', this.selectedMark?.name, this.selectedDetail?.name);
    }
  },
  methods: {
    clear() {
      this.selectedMark = null;
      this.$emit('set-detail');
    },
    apply() {
      if (this.selectedMark) {
        this.$emit('set-selected-parts', this.selectedMark.name, this.selectedDetail?.name);
        this.$emit('set-detail', this.selectedMark.id, this.selectedDetail?.id);
        this.$emit('close-parts');
      }
    },
  },
}
</script>
